import { render, staticRenderFns } from "./psw-reset.vue?vue&type=template&id=26624ece&scoped=true"
import script from "./psw-reset.vue?vue&type=script&lang=js"
export * from "./psw-reset.vue?vue&type=script&lang=js"
import style0 from "./psw-reset.vue?vue&type=style&index=0&id=26624ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26624ece",
  null
  
)

export default component.exports